<template>
  <NavBar></NavBar>
  <Router-View :key="$route.path" />
  <Footer></Footer>
</template>

<script>
import NavBar from "@/components/base/Navbar.vue";
import Footer from "@/components/base/Footer.vue";
import Messenger from "@/components/base/Messenger.vue";

export default {
  components: {
    NavBar,
    Footer,
    Messenger,
  },
};
</script>
